import React, { useEffect, useState } from "react";
import { viewSettlementSchedule } from "../../../Services/GNA/GetData";
import Styles from "./CompanyDetails.module.css";
import Settlement from "../../Modals/Schedule/Settlement/Settlement";
import { useSelector } from "react-redux";

const SchdeuleTable = ({ id, companyId }) => {
  const role = useSelector((state) => state?.persistedReducer?.user?.activeRole);
  const [scheduleList, setScheduleList] = useState(null);
  const [settlement, setSettlement] = useState({ status: false, id: "", data: "" });

  useEffect(() => {
    renderScheuleData();
  }, [id, companyId]);

  const renderScheuleData = async () => {
    const res = await viewSettlementSchedule({ type: `consumerId=${id}`, companyId });
    if (res?.data) setScheduleList(res.data?.data?.page || []);
  };

  const getActivityLabel = (ele) => {
    if (role === "MAKER") {
      return ele?.status === "PAYMENT" || ele?.status === "CHECKER" ? "View Transaction" : "Settle Transaction";
    }
    if (role === "CHECKER") {
      return ele?.status === "PAYMENT" ? "View Transaction" : "Settle Transaction";
    }
    return "View";
  };

  return (
    <>
      {settlement.status && (
        <Settlement
          open={settlement.status}
          handleClose={() => setSettlement({ status: false, id: "", data: "" })}
          id={settlement.id}
          data={settlement.data}
          admin={true}
          renderScheuleData={renderScheuleData}
        />
      )}

      {/* Header */}
      <div className={Styles.ltHead}>
        <div style={{ flex: "2" }}   className={Styles.ltHeadCell}>Company</div>
        <div style={{ flex: "1.2" }} className={`${Styles.ltHeadCell} ${Styles.ltCenter}`}>Date</div>
        <div style={{ flex: "1.8" }} className={`${Styles.ltHeadCell} ${Styles.ltCenter}`}>Time</div>
        <div style={{ flex: "1.8" }} className={`${Styles.ltHeadCell} ${Styles.ltCenter}`}>Delivered Volume (MWh)</div>
        <div style={{ flex: "1.5" }} className={`${Styles.ltHeadCell} ${Styles.ltCenter}`}>Rate (₹/kWh)</div>
        <div style={{ flex: "1.2" }} className={`${Styles.ltHeadCell} ${Styles.ltCenter}`}>Status</div>
        <div style={{ flex: "1.8" }} className={`${Styles.ltHeadCell} ${Styles.ltCenter}`}>Activity</div>
      </div>

      {scheduleList === null ? (
        <div className={Styles.ltNoResult}>Loading…</div>
      ) : scheduleList.length === 0 ? (
        <div className={Styles.ltNoResult}>No payment schedules found</div>
      ) : (
        scheduleList.map((ele, index) => (
          <div key={index} className={Styles.ltRow}>
            <div style={{ flex: "2" }} className={Styles.ltCell}>
              {ele?.counterPartyCompanyName || "—"} {ele?.scheduleId ? `· ${ele.scheduleId}` : ""}
            </div>
            <div style={{ flex: "1.2" }} className={`${Styles.ltCell} ${Styles.ltCenter}`}>{ele?.fromDate || "—"}</div>
            <div style={{ flex: "1.8" }} className={`${Styles.ltCell} ${Styles.ltCenter}`}>
              {ele?.fromBlock?.timeBlock?.split("-")?.[0]} – {ele?.toBlock?.timeBlock?.split("-")?.[1]}
            </div>
            <div style={{ flex: "1.8" }} className={`${Styles.ltCell} ${Styles.ltCenter}`}>
              {ele?.deliveredVolume != null ? ele.deliveredVolume.toFixed(2) : "—"}
            </div>
            <div style={{ flex: "1.5" }} className={`${Styles.ltCell} ${Styles.ltCenter}`}>
              {ele?.energyRate != null ? ele.energyRate.toFixed(2) : "—"}
            </div>
            <div style={{ flex: "1.2" }} className={`${Styles.ltCell} ${Styles.ltCenter}`}>
              <span className={`${Styles.statusPill} ${
                ele?.status === "PAYMENT" ? Styles.status_active :
                ele?.status === "MAKER" || ele?.status === "CHECKER" ? Styles.status_pending : ""
              }`}>
                {ele?.status === "PAYMENT" ? "DELIVERED" : ele?.status}
              </span>
            </div>
            <div style={{ flex: "1.8" }} className={`${Styles.ltCell} ${Styles.ltCenter}`}>
              {role === "CHECKER" && ele?.status === "MAKER" ? (
                <span className={Styles.docTileEmpty}>—</span>
              ) : (
                <button
                  className={Styles.scheduleActionBtn}
                  onClick={() => setSettlement({ status: true, id: ele?.settlementId, data: ele })}
                >
                  {getActivityLabel(ele)}
                </button>
              )}
            </div>
          </div>
        ))
      )}
    </>
  );
};

export default SchdeuleTable;
